import { ActionTypes } from '../constants/index';

export const fetchCommssionDetails = (payload: any) => ({
  type: ActionTypes.COMMISSION_DETAILS_REQUEST,
  payload,
});